import { fetchEmailVerified, resendVerificationEmail } from '@/lib/api';

export default {
  state: {
    emailVerified: false,
  },

  getters: {
    isEmailVerified(state) {
      return state.emailVerified === true;
    },
  },

  mutations: {
    updateEmailVerified(state, emailVerified) {
      state.emailVerified = emailVerified;
    },
  },

  actions: {
    async fetchEmailVerified({ commit }) {
      const emailVerified = await fetchEmailVerified.execute();
      commit('updateEmailVerified', emailVerified);
    },
    async resendVerificationEmail() {
      await resendVerificationEmail.execute();
    },
  },
};
